import { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import cx from 'classnames';

const userTypeOptions = [
  { value: 'employee', label: 'Employee' },
  { value: 'resident', label: 'Resident' },
  { value: 'representative', label: 'Representative' },
  { value: 'other', label: 'Other' },
];

const infoTypeOptions = [
  { value: 'name', label: 'Name', allowFor: ['employee', 'resident', 'representative'] },
  { value: 'last_name', label: 'Last Name', allowFor: ['employee', 'resident', 'representative'] },
  { value: 'position', label: 'Position', allowFor: ['employee'] },
  { value: 'email', label: 'Email', allowFor: ['resident', 'representative'] },
  { value: 'phone_number', label: 'Phone Number', allowFor: ['resident', 'representative'] },
  { value: 'relation', label: 'Relation', allowFor: ['representative'] },
  { value: 'date', label: 'Date', allowFor: ['other'] },
  { value: 'month', label: 'Month', allowFor: ['other'] },
  { value: 'year', label: 'Year', allowFor: ['other'] },
  { value: 'gender', label: 'Gender', allowFor: ['resident'] },
  { value: 'date_of_birth', label: 'Date of Birth', allowFor: ['resident'] },
  { value: 'SSN', label: 'SSN', allowFor: ['resident'] },
  { value: 'address', label: 'Address', allowFor: ['resident'] },
  { value: 'address_2', label: 'Address 2', allowFor: ['resident'] },
  { value: 'city', label: 'City', allowFor: ['resident'] },
  { value: 'state', label: 'State', allowFor: ['resident'] },
  { value: 'zip', label: 'Zip', allowFor: ['resident'] },
  { value: 'facility_name', label: 'Facility Name', allowFor: ['resident'] },
  { value: 'unit_name', label: 'Unit Name', allowFor: ['resident'] },
  { value: 'physician_name', label: 'Physician Name', allowFor: ['resident'] },
  { value: 'medical_record_number', label: 'Medical Record Number', allowFor: ['resident'] },
  { value: 'date_of_admission', label: 'Date of Admission', allowFor: ['resident'] },
  { value: 'room_number', label: 'Room Number', allowFor: ['resident'] },
];

const AutoFillingPropertyItem = ({ variable, updateFormAutoFillingVariables, autoFillingVariables }) => {
  const [formData, setFormData] = useState({
    userType: userTypeOptions.find(({ value }) => value === variable.user_type),
    infoType: infoTypeOptions.find(({ value }) => value === variable.info_type),
  });
  const [isOpen, setIsOpen] = useState(false);
  const isFirstRender = useRef(true);

  const handleChangeFormUserType = (e) => {
    setFormData((state) => ({
      userType: e,
      infoType:
        infoTypeOptions.filter(({ allowFor }) => allowFor.includes(e.value)).find(({ value }) => value === state.infoType?.value) || null,
    }));
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    updateFormAutoFillingVariables(
      autoFillingVariables.map((item) =>
        item.id === variable.id ? { ...item, user_type: formData.userType?.value, info_type: formData.infoType?.value || null } : item,
      ),
    );
  }, [formData]);

  return (
    <div className="variable-item">
      <div className={cx('variable-item-header', { isEmpty: !formData.infoType || !formData.userType })} onClick={() => setIsOpen(!isOpen)}>
        {variable.name}
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 7.5L10 12.5L15 7.5" stroke="#98A2B3" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>

      {isOpen && (
        <div className="variable-item-form">
          <div className="form-item form-item-select">
            <label className="form-label">Type</label>
            <Select
              options={userTypeOptions}
              className="form-control-select"
              classNamePrefix="react-select"
              value={formData.userType}
              onChange={(e) => handleChangeFormUserType(e)}
              placeholder="Select"
              isSearchable={false}
            />
          </div>
          <div className="form-item form-item-select">
            <label className="form-label">Type of information</label>
            <Select
              options={infoTypeOptions.filter(({ allowFor }) => allowFor.includes(formData.userType?.value))}
              className="form-control-select"
              classNamePrefix="react-select"
              value={formData.infoType}
              menuPlacement="auto"
              isDisabled={!formData.userType}
              onChange={(e) => setFormData({ ...formData, infoType: e })}
              placeholder="Select"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AutoFillingPropertyItem;
